import {PullRequestCcrAdoptionNudge, type PullRequestCcrAdoptionNudgeProps} from './PullRequestCcrAdoptionNudge'

export type PullRequestCcrAdoptionNudgePartialProps = PullRequestCcrAdoptionNudgeProps

export function PullRequestCcrAdoptionNudgePartial(props: PullRequestCcrAdoptionNudgePartialProps) {
  return <PullRequestCcrAdoptionNudge {...props} />
}
